import { useAppSelector } from '@app/hooks';
import { RootState } from '@app/store';
import PerformanceDashboard from '@features/home-analytics/components/PerformanceDashboard';
import { Box, Typography } from '@mui/material';
import { useMemo } from "react";

  const HomeAnalyticsView = () => {
    const userTenant = useAppSelector((state: RootState) => state.userTenant);
    const tenant = useAppSelector((state: RootState) => state.tenant);
    const property = useAppSelector((state: RootState) => state.property);

    const currentTenant = useMemo(() => tenant.currentTenant || userTenant, [tenant.currentTenant, userTenant]);

    if (!currentTenant || !property) return <></>;

    return (
      <Box
        component="div"
        sx={{
          margin: '1em',
          padding: '2em',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            mb: '2em'
          }}
        >
          Performance Analytics for {property.name}
        </Typography>
        <PerformanceDashboard />
      </Box>
    );
  }

  export default HomeAnalyticsView;